module.exports = __webpack_public_path__ + "img/Weapon_81.4137c629.png";